import { AdminRescheduleAction } from "./AdminRescheduleAction"
import { CancelAction } from "./CancelAction"
import { ChangeTypeAction } from "./ChangeTypeAction"
import { ReassignAction } from "./ReassignAction"
import { RescheduleAction } from "./RescheduleAction"
import { StatusAction } from "./StatusAction"
import type { BookingAction, BookingActionId } from "./types"

/**
 * The appointment dialog's writes, in the order their triggers are drawn. Each lives in its own file;
 * adding one is a new file and a line here.
 *
 * "Link rescheduled booking" (./LinkRescheduledAction) is not offered for now: the human asked on
 * 2026-10-30 to hide it while the feature is polished. The action, its API and its tests are unchanged;
 * importing it and listing it last here brings it back.
 */
export const bookingActions: readonly BookingAction[] = [
  CancelAction,
  ReassignAction,
  StatusAction,
  RescheduleAction,
  AdminRescheduleAction,
  ChangeTypeAction,
]

export function findBookingAction(id: BookingActionId): BookingAction | undefined {
  return bookingActions.find(action => action.id === id)
}
